import { render, staticRenderFns } from "./userbankcard.vue?vue&type=template&id=8cd832e0&"
import script from "./userbankcard.vue?vue&type=script&lang=js&"
export * from "./userbankcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports